module.exports = __webpack_public_path__ + "img/no-img-lg.30a7a08e.png";